import { Injectable } from '@angular/core';
import { ApiService } from '../core/services/api.service';
import { ConfigService } from '../core/services/config.service';
import { APIENDPOINTS } from '../common/constants';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LookupService {
  private subregions: BehaviorSubject<any>;
  private programs: BehaviorSubject<any>;
  private tgs: BehaviorSubject<any>;
  constructor(private apiService: ApiService, private configService: ConfigService) {
    this.subregions = new BehaviorSubject<any>([]);
    this.programs = new BehaviorSubject<any>([]);
    this.tgs = new BehaviorSubject<any>([]);
  }

  get ibraSubregions(): Observable<any>{
    if (this.subregions != null && this.subregions!=undefined && this.subregions.value.length>0) return this.subregions.asObservable();
    else{
      this.apiService.findAll<any>(this.configService.LookupUrl + '/ibrasubregions').subscribe(result => {
        this.subregions.next(result);
      });
      return this.subregions.asObservable();
    }
    
  }

  getClassifications(types: string[]): Observable<any> {
    return this.apiService.findAll(this.configService.ClassificationsUrl + (types.length ? '/' + types : ''));
  }
  getOffsetTradingGroups(): Observable<any> {
    if (this.tgs != null && this.tgs != undefined && this.tgs.value.length > 0) return this.tgs.asObservable();
    else {
      this.apiService.findAll(this.configService.TradingGroupsUrl).subscribe(result => {
        this.tgs.next(result);
      });
      return this.tgs.asObservable();
    }
    //return this.apiService.findAll(this.configService.TradingGroupsUrl);
  }

  get Programs(): Observable<any> {
    if (this.programs != null && this.programs != undefined && this.programs.value.length > 0) return this.programs.asObservable()
    else {
      this.apiService.findAll<any>(this.configService.ActieProgramsUrl).subscribe(result => {
        this.programs.next(result);
      });
      return this.programs.asObservable();
    }
  }

  getLGAs() {
    let apiEndpoint = this.configService.LookupUrl + "/lgas";
    return this.apiService.find<any>(apiEndpoint);
  }

  getDevelopmentTypes() {
    let apiEndpoint = this.configService.LookupUrl + "/developmenttypes";
    return this.apiService.find<any>(apiEndpoint);
  }

  getIbraRegions(): Observable<any> {
    let apiEndpoint = this.configService.LookupUrl + "/ibraregions";
    return this.apiService.find<any>(apiEndpoint);
    
  }

}
